import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setMagazines: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 详情
export const setMagazineDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 授权企业列表
export const setMagazineAuths: Mutation<IModuleState> = (state, payload) => {
  state.auths.data = payload.data;
  state.auths.pageNum = payload.pageNum;
  state.auths.pageSize = payload.pageSize;
  state.auths.total = payload.total;
  state.auths.loading = !!payload.loading;
};

// 未授权企业列表
export const setMagazineUnAuths: Mutation<IModuleState> = (state, payload) => {
  state.unAuths.data = payload.data;
  state.unAuths.pageNum = payload.pageNum;
  state.unAuths.pageSize = payload.pageSize;
  state.unAuths.total = payload.total;
  state.unAuths.loading = !!payload.loading;
};

// 上下架结果
export const setShelfCheck: Mutation<IModuleState> = (state, payload) => {
  state.shelfCheck.data = payload.data;
  state.shelfCheck.params = payload.params;
  state.shelfCheck.visible = !!payload.visible;
  state.shelfCheck.loading = !!payload.loading;
};

// 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.name = payload.name;
};

// 设置列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
